import { ProgressCircleComponent } from "@/components/progress/progress-circle";
import { toaster } from "@/components/ui/toaster";
import { Tooltip } from "@/components/ui/tooltip";
import { AppRoutes } from "@/constants/routes";
import { useAuth } from "@/hooks/useAuth";
import { AppColors } from "@/styles/colors";
import { Avatar, Flex, IconButton, Text } from "@chakra-ui/react";
import { LogOut } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const UserInfo = () => {
  const { user, logout } = useAuth();

  const [loadingLogout, setLoadingLogout] = useState<boolean>(false);

  const navigate = useNavigate();

  const handleLogout = async () => {
    setLoadingLogout(true);
    const response = await logout();
    setLoadingLogout(false);
    if (response) {
      toaster.create({
        title: "Sesión cerrada con éxito.",
        type: "success",
      });
      navigate(AppRoutes.LOGIN);
    } else {
      toaster.create({
        title: "Hubo un error al cerrar la sesión",
        type: "error",
      });
    }
  };
  return (
    <Flex
      alignItems="center"
      width="100%"
      position="absolute"
      bottom="4"
      bgColor={AppColors.WHITE_SECONDARY}
      justifyContent="space-between"
      paddingX="12px"
    >
      <Flex gap="15px">
        <Avatar.Root>
          <Avatar.Fallback name={user?.name} />
        </Avatar.Root>
        <Flex flexDir="column">
          <Text fontWeight={400} fontSize="16px" color={AppColors.GRAY_TEXT}>
            {user?.name}
          </Text>
          <Text fontWeight={400} fontSize="14px">
            Administrador
          </Text>
        </Flex>
      </Flex>
      <Tooltip
        content="Cerrar sesión"
        contentProps={{
          css: {
            paddingX: "10px",
          },
        }}
      >
        {loadingLogout ? (
          <ProgressCircleComponent size="sm" />
        ) : (
          <IconButton variant="plain" onClick={handleLogout}>
            <LogOut />
          </IconButton>
        )}
      </Tooltip>
    </Flex>
  );
};
